<template>
  <a class="white--text" @click="$emit('close', label)">
    <div class="grey white--text tripdivider">
      <div>
        <v-icon
          dark
          :style="{ transform: 'rotate(' + getIconRotation + 'deg)' }"
          >expand_less</v-icon
        >

        <span
          class="tripDivderlabel"
          :style="{ 'font-weight': getLabelFontWeight }"
        >
          {{ label }}
        </span>
      </div>
      <div class="count">{{ count }}</div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    label: String,
    isOpen: {
      type: Boolean,
      default: true
    },
    count: Number
  },

  computed: {
    getIconRotation: function() {
      return this.isOpen ? 180 : 0;
    },

    getLabelFontWeight: function() {
      return this.isOpen ? "bold" : "normal";
    }
  }
};
</script>

<style scoped>
.tripdivider {
  width: 100%;
  padding: 5px 10px 5px 10px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1px;
}
.tripDivderlabel {
  font-weight: bold;
  font-size: 14px;
}
.count {
  padding-right: 13px;
  font-size: 14px;
}
</style>
